import { useSnapshot } from 'valtio'
import cn from 'classnames'
import { type ReactElement } from 'react'
import { globalLayoutProxy } from '../../../../../shared/proxies/globalLayoutProxy'
import { proxyGlobalAuth } from '../../../../../shared/proxies/proxyGlobalAuth'
import StandardPayPrimarySignatureLogo
  from '../../../../../shared/components/ui/logos/StandardPayPrimarySignatureLogo'
import { GlobalSiteDomainEnum } from '../../../../../shared/types/GlobalSiteDomainEnum'
import ErrorBoundary from '../../../../../shared/components/errorBoundary/ErrorBoundary'
import PoweredByBadge from '../../../virtual-terminal/index/Payment/PoweredByBadge'
import { CustomerAddSlideOver } from '../../../../../shared/components/CustomerAddSlideOver/CustomerAddSlideOver'
import { handleSubmitForRecurringConfigurationCreate } from '../../../../../shared/components/CustomerAddSlideOver/utils'
import { handleSubmitToOpenLightboxNewRecurring } from '../../../../../shared/components/CardAddSlideOver/utils'
import { CardAddSlideOver } from '../../../../../shared/components/CardAddSlideOver/CardAddSlideOver'
import { PaymentConfigurationSummary } from './PaymentConfigurationSummary'
import { PaymentConfigurationDetails } from './PaymentConfigurationDetails'

function DeterminePoweredBy (): ReactElement {
  const { siteDomainEnum } = useSnapshot(proxyGlobalAuth)
  if (siteDomainEnum === GlobalSiteDomainEnum.WastePay) {
    return <PoweredByBadge />
  }
  return (
    <div className="flex flex-col justify-center my-5 text-xs text-black font-medium text-center h-20">
      <span className="w-full opacity-80">Secure Payments Powered by</span>
      <div className="w-full px-24 justify-center">
        <StandardPayPrimarySignatureLogo />
      </div>
    </div>
  )
}

export function PaymentConfiguration (): ReactElement {
  const { sidebarExpanded, accountDropdownExpanded } = useSnapshot(globalLayoutProxy)
  return (
    <>
      <div className="flex">
        <PaymentConfigurationDetails />
        <div
          className={cn('fixed right-12 transition-all duration-150', accountDropdownExpanded && '-z-10')}
          style={{ top: '10.75em', width: sidebarExpanded ? '25%' : '29%' }}
        >
          <ErrorBoundary>
            <PaymentConfigurationSummary />
          </ErrorBoundary>
          <DeterminePoweredBy />
        </div>
        <CardAddSlideOver submitFunction={handleSubmitToOpenLightboxNewRecurring} />

        <CustomerAddSlideOver submitFunction={handleSubmitForRecurringConfigurationCreate} />
      </div>
    </>
  )
}
